import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { SecretsOfAnubis_ResponsivePIXIApp } from "../SecretsOfAnubis/game_ResponsivePIXIApp";

export class SecretsOfAnubisLink_ResponsivePIXIApp extends SecretsOfAnubis_ResponsivePIXIApp {

    constructor(multigameParams: MultigameParams, initData: SlotGameInitData ) {
        super(multigameParams, initData, "SecretsOfAnubisLink");
    }
    
}

  


